import React from 'react';
import { ReactComponent as UploadPictureIcon } from '../../icons/upload_chat_picture.svg';
import s from './UploadImage.module.css';

export function UploadImage({
  inputRef,
  onChange,
  previewUrl,
  accept = 'image/*',
  title = 'Загрузить изображение',
  ariaLabel = 'Загрузить изображение',
}) {
  const innerRef = React.useRef(null);
  const ref = inputRef ?? innerRef;

  const handleClick = () => {
    ref.current?.click();
  };

  return (
    <div className={s.uploadImage}>
      <button
        type="button"
        className={s.btn}
        onClick={handleClick}
        title={title}
        aria-label={ariaLabel}
      >
        {previewUrl ? (
          <img src={previewUrl} alt="" className={s.preview} />
        ) : (
          <UploadPictureIcon />
        )}
      </button>
      <input
        ref={ref}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={onChange}
      />
    </div>
  );
}
